import styled from "styled-components";

export const StyledFormation = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 20px 0;
  gap: 20px;

  & .formation-content {
    flex-grow: 1;
  }
`;
